import React from 'react';
import OnboardingInfo from './signUp/OnboardingInfo';
import { PrivacyInformation } from './PrivacyInformation/PrivacyInformation';
import { LanguageSelector } from '../../common/localization';
import LogoBlack from '../../../assets/images/svg/validatelogoblack.svg';

export const OnboardingLayout = ({ children, locales, data }) => {
  const { onboarding: pageLocales } = locales;
  return (
    <div className="w-screen min-h-screen flex items-center justify-center">
      <div className="w-full flex items-center justify-center">
        <main className="sign-up-page">
          <section className="sign-up-form-section flex flex-col h-full overflow-y-auto">
            <div>
              {data.imageUrl && (
                <div className="sign-up-form-section__establishment-image">
                  <img src={data.imageUrl} alt="establishment-logo" />
                </div>
              )}
              <div className="flex justify-between">
                <img
                  className="h-10 w-auto"
                  src={LogoBlack}
                  alt={pageLocales.titles.logo}
                />
                <div className="flex items-center">
                  <LanguageSelector />
                </div>
              </div>
            </div>
            <div className="flex flex-col flex-grow">{children}</div>
            <footer className="pt-12 pl-4 pr-4 w-full">
              <PrivacyInformation pageLocales={pageLocales} />
            </footer>
          </section>
          <section className="flex-1 hidden xl:block">
            <OnboardingInfo locales={locales} />
          </section>
        </main>
      </div>
    </div>
  );
};
